import React from "react"
import PropTypes from "prop-types"
import {Box, Chip, Stack, Typography} from "@mui/material"

const WorkflowErrorPanel = ({error}) => {
    if (!error) return null
    const details = error.details && typeof error.details === "object" ? error.details : {}

    return (
        <Box sx={{border: "1px solid", borderColor: "error.main", borderRadius: 1, p: 2}}>
            <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{mb: 1}}>
                <Chip size="small" color="error" label={error.code || error.error_type || "ERRO"}/>
                <Chip
                    size="small"
                    variant="outlined"
                    label={error.retryable ? "Retentável" : "Definitivo"}
                    sx={{color: "common.white", borderColor: "primary.white30"}}
                />
            </Stack>
            <Typography variant="body2" color="common.white" sx={{wordBreak: "break-word"}}>
                {error.message || "Sem mensagem disponível"}
            </Typography>
            {(details.source || details.origin || details.curve) && (
                <Typography variant="caption" color="primary.white70" display="block" sx={{mt: 1}}>
                    Origem: {details.source || details.origin || "—"} · Curva: {details.curve || "—"}
                </Typography>
            )}
            {Object.keys(details).length > 0 && (
                <Box
                    component="pre"
                    sx={{
                        mt: 1,
                        mb: 0,
                        p: 1.5,
                        fontSize: 11,
                        color: "primary.white70",
                        backgroundColor: "primary.white05",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                    }}
                >
                    {JSON.stringify(details, null, 2)}
                </Box>
            )}
        </Box>
    )
}

export const workflowErrorShape = PropTypes.shape({
    id: PropTypes.number,
    fingerprint: PropTypes.string,
    code: PropTypes.string,
    error_type: PropTypes.string,
    message: PropTypes.string,
    details: PropTypes.object,
    retryable: PropTypes.bool,
})

WorkflowErrorPanel.propTypes = {error: workflowErrorShape}

export default WorkflowErrorPanel
